export default __webpack_public_path__ + "static/media/17-2.4d51bc41.mp3";